// extracted by mini-css-extract-plugin
export default {"brandPromo":"VF-z","carousel":"WF-z"};